
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "time-picker-component"
})
export default class TimePickerComponent extends Vue {
  public menu = false;

  @Prop({type: Object})
  public obj!: object;

  @Prop({type: String, default: 'Horário'})
  public label!: string;

  @Prop({type: Array})
  public rules!: Array<any>;

  @Prop({type: Number, default: 5})
  public counter!: number;

  @Prop({type: Number, default: 5})
  public maxlength!: number;

  @Prop({type: Boolean, default: false})
  public readonly!: boolean;

  @Prop({type: Boolean, default: false})
  public disabled!: boolean;
}
